import { createContext, useEffect, useState } from 'react';

import { requestService } from 'shared/utils/services/requestService';
import { bugsnag } from 'shared/utils/services/bugsnag';

export const CountriesContext = createContext(null);

export const CountriesProvider = ({ children }) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const { countries: countriesData } = await requestService({
          url: '/web-api/v1/countries',
          method: 'GET',
        });
        setCountries(countriesData);
      } catch (error) {
        bugsnag(error, { context: 'CountriesProvider' });
      }
    };

    void fetchCountries();
  }, []);

  return <CountriesContext.Provider value={countries}>{children}</CountriesContext.Provider>;
};
